"use strict";
var ko = require("knockout");
var $ = require("jquery");
var moment = require("moment");
var dateTimeUtils_1 = require("../utils/dateTimeUtils");
ko.bindingHandlers["time"] = {
    update: function (element, valueAccessor, allBindings) {
        var value = ko.unwrap(valueAccessor()), $el = $(element), time = moment(value);
        if (!time.isValid()) {
            return;
        }
        var format = allBindings.get("format");
        var formattedText;
        if (format === undefined || format === null || format.indexOf("calendar") !== -1) {
            formattedText = dateTimeUtils_1.default.formatCalendar(time, format);
        }
        else {
            formattedText = time.format(format);
        }
        $el.attr("data-hint", time.format("D MMMM YYYY в HH:mm:ss"));
        $el.html(formattedText);
    }
};
//# sourceMappingURL=ko.time.js.map